class KitHowToUse extends HTMLElement {
  connectedCallback() {
    this._steps    = Array.from(this.querySelectorAll('.khtu__step'));
    this._rings    = this._steps.map(s => s.querySelector('.khtu__ring-fill'));
    this._C        = 283;
    this._duration = 3500;
    this._observeEntrance();
    this._initCollapsible();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this._raf);
    clearTimeout(this._to);
  }

  /* ── ENTRANCE + RING ANIMATION (original) ───────────────────────────── */

  _observeEntrance() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('is-visible');
      });
      if (this._steps.every(s => s.classList.contains('is-visible'))) {
        io.disconnect();
        this._to = setTimeout(() => this._startRing(0), 500);
      }
    }, { threshold: 0.15 });
    this._steps.forEach(s => io.observe(s));
  }

  _startRing(index) {
    if (index >= this._steps.length) {
      this._rings.forEach(r => {
        if (r) r.style.strokeDashoffset = this._C;
      });
      this._to = setTimeout(() => this._startRing(0), 500);
      return;
    }
    const ring = this._rings[index];
    if (!ring) { this._startRing(index + 1); return; }

    const t0  = performance.now();
    const dur = this._duration;
    const C   = this._C;

    const tick = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      ring.style.strokeDashoffset = C * (1 - p);
      if (p < 1) {
        this._raf = requestAnimationFrame(tick);
      } else {
        ring.style.strokeDashoffset = 0;
        this._to = setTimeout(() => this._startRing(index + 1), 250);
      }
    };
    this._raf = requestAnimationFrame(tick);
  }

  /* ── COLLAPSIBLE ACCORDION ──────────────────────────────────────────── */

  _initCollapsible() {
    this._toggles = Array.from(this.querySelectorAll('.khtu__toggle'));
    this._toggles.forEach(btn => {
      btn.addEventListener('click', () => this._onToggle(btn));
    });
  }

  _onToggle(btn) {
    const step        = btn.closest('.khtu__step');
    const collapsible = step.querySelector('.khtu__collapsible');
    const isOpen      = btn.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this._close(step, btn, collapsible);
    } else {
      this._steps.forEach(s => {
        if (s === step) return;
        const b = s.querySelector('.khtu__toggle');
        const c = s.querySelector('.khtu__collapsible');
        if (b && b.getAttribute('aria-expanded') === 'true') {
          this._close(s, b, c);
        }
      });
      this._open(step, btn, collapsible);
    }
  }

  _open(step, btn, collapsible) {
    collapsible.style.maxHeight  = collapsible.scrollHeight + 'px';
    collapsible.style.opacity    = '1';
    collapsible.style.visibility = 'visible';
    collapsible.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    step.classList.add('khtu__step--open');
  }

  _close(step, btn, collapsible) {
    collapsible.style.maxHeight = '0';
    collapsible.style.opacity   = '0';
    collapsible.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    step.classList.remove('khtu__step--open');

    collapsible.addEventListener('transitionend', () => {
      collapsible.style.visibility = 'hidden';
    }, { once: true });
  }
}

if (!customElements.get('kit-how-to-use')) {
  customElements.define('kit-how-to-use', KitHowToUse);
}
